import { Text, Link, Grid } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import {
  OutlineDocument,
  PageWrapper,
  TOPNAVBAR_HEIGHT,
} from "src/shared/components";
import { Route } from "src/shared/constants/route";

import { WORKSHOP_SECTIONS } from "./constants";

const StyledPageWrapper = styled(PageWrapper)`
  background-color: ${({ theme }) => theme.globalConstants.color.white};
`;

const Section = styled.section`
  padding: 32px;
  border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGrey};
  border-radius: ${({ theme }) => theme.globalConstants.borderRadius.medium}px;
  box-shadow: ${({ theme }) => theme.globalConstants.boxShadow.regular};
  background: ${({ theme }) => theme.globalConstants.color.white};
`;

const TableOfContents = styled(Section)`
  width: 220px;
`;

const StyledLink = styled(Link)`
  text-decoration: none !important;
  :hover {
    text-decoration: underline !important;
  }
`;

const SCROLL_OFFSET = 50;

const SectionScrollTarget = styled.div`
  position: relative;
  top: -${TOPNAVBAR_HEIGHT + SCROLL_OFFSET}px;
`;

const WORKSHOPS_SHARE_ID = "0079e171-beb5-49a4-81b6-c63ca91b6986";

const Workshops: React.FC = () => (
  <StyledPageWrapper scrollToTop>
    <Grid columns={1} rows="auto" rowGap={48}>
      <OutlineDocument shareId={WORKSHOPS_SHARE_ID} />
      <TableOfContents>
        <Grid columns={1} rows="auto" rowGap={12}>
          <Text mods="heading h2">Topics</Text>
          {WORKSHOP_SECTIONS.map(({ label, sectionId }) => (
            <StyledLink
              mods="medium big"
              key={sectionId}
              href={`${Route.HACKER_WORKSHOPS}/#${sectionId}`}
            >
              {label}
            </StyledLink>
          ))}
        </Grid>
      </TableOfContents>
      {WORKSHOP_SECTIONS.map(({ sectionId, shareId }) => (
        <Section key={sectionId}>
          <SectionScrollTarget id={sectionId} />
          <OutlineDocument shareId={shareId} noTitle />
        </Section>
      ))}
    </Grid>
  </StyledPageWrapper>
);

export default Workshops;
